module.exports = __webpack_public_path__ + "static/desktop-bloom-95869a071d659c58916b9a9a2341e012.webp";